import { Form } from 'antd'
import { FC } from 'react'
import { ContactEntry } from '../../contact/type/contact-entry'
import { Container, ShowIf } from '../../../core/component'
import { useQuery, gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableResponse, QueryPageableRequest } from '../../../core/type'
import { Contact, WebInfoType } from '../../contact/type/contact'
import { ContactFindRequest } from '../../contact/type/contact.query'
import { ContactFormRelations } from '../../contact/component/ContactFormRelations'
import { ContactPageContext } from '../../contact/component/ContactPageContext'

const GetRelationsQuery: TypedDocumentNode<
  QueryPageableResponse<Contact, 'contactsFind'>,
  QueryPageableRequest<ContactFindRequest>> = gql`
        query GetRelationsOfContact($request: ContactFindRequest!) {
            contactsFind(request: $request) {
                data {
                    id
                    relations {
                        id
                        contactId
                        firstName
                        lastName
                        addresses {
                            id  
                            city
                            street
                            line1
                            line2
                        }
                        phones {
                            number
                        }
                        webInfos {
                            type
                            value
                        }
                    }
                }
            }
        }
      `

export const OrderFormCustomerRelations: FC<{ customerId?: string }> = ({ customerId }) => {
  const [form] = Form.useForm<Pick<ContactEntry, 'relations'>>()

  const { data: parent, loading, refetch } = useQuery(GetRelationsQuery, {
    skip: !customerId,
    notifyOnNetworkStatusChange: true,
    variables: {
      request: {
        contactId: customerId,
        take: 1,
        skip: 0,
      },
    },
    onCompleted: data => {
      form.setFieldsValue({
        relations: data?.contactsFind.data[0].relations.map(r => {
          const [address] = r.addresses
          const [phone] = r.phones

          return {
            id: r.id,
            contactId: r.contactId,
            firstName: r.firstName,
            lastName: r.lastName,
            addressId: address?.id,
            phoneId: phone?.id,
            city: address?.city,
            street: address?.street,
            line1: address?.line1,
            line2: address?.line2,
            phone: phone?.number,
            email: r.webInfos.find(w => w.type === WebInfoType.EmailAddress)?.value,
          }
        })
      })
    },
  })

  return (
    <Container
      loading={loading}
    >
      <ShowIf
        condition={!!customerId}
        replacement={<></>}
      >
        <ContactPageContext.Provider
          value={{
            entity: parent?.contactsFind.data?.[0],
            form: form as any,
            refresh: async () => { await refetch() },
          }}
        >
          <Form
            name='customerRelations'
            form={form}
            layout='vertical'
          >
            <ContactFormRelations />
          </Form>
        </ContactPageContext.Provider>
      </ShowIf>
    </Container>
  )
}